var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',_vm._l((_vm.items),function(ref){
var name = ref.name;
var label = ref.label;
var selected = ref.selected;
var action = ref.action;
return _c('li',{key:name},[_c('a',{class:{ selected: selected },domProps:{"textContent":_vm._s(label)},on:{"click":action}}),_vm._m(0,true)])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require("@/assets/icons/chevron-forward-white.svg"),"alt":"chevron"}})])}]

export { render, staticRenderFns }